module.exports = __webpack_public_path__ + "img/audio_conferencing.cf4edf96.svg";